import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import {
  Button,
  ButtonIcon,
  FormHeader,
  SectionHeader,
  TopMenu,
} from "../../components";
import "react-notifications-component/dist/theme.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { resendEmailVerification } from "../AdsSignUp/services/adsSignup.service";
import { newsUserDetails, setAdsSession } from "../../utils";
import { EmailChangeModal } from "../modal";
import { openEmailChangeModal } from "../AdsPlatform/redux/actions";

const AdsVerification = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [user, setUser] = useState("");

  const { signupUser, isOpenEmailChangeModal } = useSelector(
    ({ adsUserReducer }) => adsUserReducer
  );

  const dispatch = useDispatch();

  const onClickResendEmailVerification = async () => {
    setIsLoading(true);
    try {
      let newsUser = newsUserDetails();
      let user = newsUser || signupUser;

      if (user) {
        let resVerify = await resendEmailVerification({
          company_id: user?.company_id,
          email: user?.working_email,
        });
        if (resVerify.data.status) {
          console.log("resVerify", resVerify.data);
          setAdsSession(resVerify.data?.data?.token);
          setIsLoading(false);
          setIsDisable(true);
        } else {
          notification.error({
            message: "Error",
            description: resVerify.data.message,
          });
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error resending email verification:", error);
      setIsLoading(false);
      notification.error({
        message: "Error",
        description: "Failed to resend verification email. Please try again.",
      });
    }
  };

  // set a timer to automatically active resend button after 30 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDisable(false);
    }, 30000); // 30 seconds

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, []);

  useEffect(() => {
    let companyUser = newsUserDetails();
    if (companyUser?.company_id) {
      setUser(companyUser);
    }
  }, []);

  const fetchEmail = (value) => {
    return value.replace(
      /^[ ]*([^@\s])([^@\s]*)(@(?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i,
      (_, firstChar, rest, domain) =>
        `${firstChar}${"*".repeat(rest.length)}${domain}`
    );
  };

  return (
    <>
      {isOpenEmailChangeModal && <EmailChangeModal />}
      <div className={"ads-verification-wrapper"}>
        <div>
          <TopMenu
            data={{
              size: "sm",
              isLanguage: false,
              isLogo: false,
              isProfile: false,
            }}
          />
        </div>
        <div className={"avw__main-wrp"}>
          <div className={"avw__nagivator"}>
            <ButtonIcon
              data={{
                iconName: "h-wrrow-left",
                size: "md",
                type: "light",
              }}
              onClick={() => {
                if (user?.company_id) {
                  props.history.push("/");
                } else {
                  props.history.push("/ads");
                }
              }}
            />
            Back to home
          </div>
          <div className={"avw__form"}>
            <div className={"avwf__header-wrapper"}>
              <div className={"avwf__hw-logo"}>
                <img
                  src={require("../../assets/img/logo_new.png")}
                  alt={"logo"}
                />
              </div>
              <FormHeader
                data={{
                  formHeader: "We’ve sent a verification email to",
                  size: "md-md",
                }}
              />
              <SectionHeader
                data={{
                  title:
                    ((signupUser?.working_email || user?.working_email) &&
                      fetchEmail(
                        signupUser?.working_email || user?.working_email
                      )) ||
                    "your email",
                  size: "md-sm",
                }}
              />
            </div>
            <div className={"avwf__content"}>
              <span>Check your email!</span>
              <span>
                We’ve sent you an magic link Click the button to activate
              </span>
              <span>your account.</span>
            </div>
            <div className={"avwf__find"}>Still can’t find the email ?</div>
            <Button
              data={{
                btnName: "RESEND MAIL",
                buttonType: isDisable ? "primary disabled" : "primary",
                buttonSize: "lg",
                isLoading: isLoading,
                disable: isDisable,
              }}
              onClick={async (e) => {
                console.log("Clicked||");
                e.preventDefault();
                await onClickResendEmailVerification(e);
              }}
            />
            <div className={"avwf__re-enter"}>
              <div className={"d-flex flex-row"}>
                You can re-enter email
                {"  "}
                <span
                  className={"avwf__re-here pl-1"}
                  onClick={() => {
                    dispatch(openEmailChangeModal(signupUser));
                  }}
                >
                  {" "}
                  here
                </span>
                , if the one you entered was
              </div>
              <span>incorrect</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(AdsVerification);
